import { VisitorsLayoutV2 } from 'components/visitors-layout-v2';
import { VisitsV2Routes } from 'components/root/router/visitor-registration-route/visits-v2-routes';

/**
 * Main V2 page component for visitor management
 * Uses VisitorsLayoutV2 and VisitsV2Routes
 */
export const VisitsPageV2 = (): JSX.Element => (
  <VisitorsLayoutV2>
    <style>
      {`
    html, body {
    -webkit-font-smoothing: auto!important;
    }`}
    </style>
    <VisitsV2Routes />
  </VisitorsLayoutV2>
);
